import { useForm } from '../../../../../shared/form/useForm';
import { IChangePasswordFormData } from '../../../model/IChangePasswordFormData';
import { useChangePasswordSchema } from './useChangePasswordSchema';

export function useChangePasswordForm() {
	const validationSchema = useChangePasswordSchema();
	const form = useForm<IChangePasswordFormData>({
		mode: 'onSubmit',
		validationSchema,
		defaultValues: {},
	});

	return form;
}
